module.exports = __webpack_public_path__ + "img/9.c31aa7ef.jpg";